import * as React from 'react';
import Link from '@mui/material/Link';


const williamsSonomaLink = "https://www.williams-sonoma.com/registry/mlgxmbcgrr/registry-list.html";

type WilliamsSonomaLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: WilliamsSonomaLinkProps = {
  linkText: "Williams Sonoma Registry",
  underline: "hover"
};

export default function WilliamsSonomaLink(linkProps: WilliamsSonomaLinkProps = defaultProps) {
  return (
          <Link href={williamsSonomaLink} 
            underline={linkProps.underline ? linkProps.underline : defaultProps.underline}
            >
            {linkProps.linkText ? linkProps.linkText : defaultProps.linkText}
          </Link>
  );
}